import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "../../../helpers/classNames";
import { DraggableComponentTypes, } from "../../../types/draggable";
import DraggableBox from "../DraggableBox";
const DraggableGrid = ({ id, children, elementId, props, }) => {
    return (_jsx(DraggableBox, { className: classNames("grid", props.className, props?.gridMobile, props?.gridTablet, props?.gridDesktop, !props.className?.includes("gap") && "gap-4"), draggableId: id, elementId: elementId, childs: children.filter((i) => true), editorKey: id, type: DraggableComponentTypes.Grid, "editor-type": "grid" }));
};
export default DraggableGrid;
//# sourceMappingURL=DraggableGrid.js.map